import React from 'react'
import { ArrowRight } from 'react-feather'
import styled from 'styled-components'
import { assignPrefix } from '../../../../constants'

const Wrapper = styled.div`
  width: 100%;
  box-shadow: 0px 0px 2.40026px rgba(0, 0, 0, 0.0115598), 0px 1.51px 6.63642px rgba(0, 0, 0, 0.0238066),
    0px 5.44px 15.9779px rgba(0, 0, 0, 0.0393306), 0px 22px 53px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  padding: ${p => p.theme.space[32]};
  margin-bottom: ${p => p.theme.space[32]};
  display: flex;
  > div {
    > strong {
      font-weight: bold;
      font-size: ${p => p.theme.fontSizes[20]};
      display: block;
      margin-bottom: 4px;
      color: ${p => p.theme.colors.gray[800]};
    }
    > p {
      color: ${p => p.theme.colors.gray[600]};
      margin: 1rem 0 1rem 1rem;
      display: list-item;
    }
  }
`

export const MeetupList = styled.div`
  width: 100%;
  box-shadow: 0px 0px 2.40026px rgba(0, 0, 0, 0.0115598), 0px 1.51px 6.63642px rgba(0, 0, 0, 0.0238066),
    0px 5.44px 15.9779px rgba(0, 0, 0, 0.0393306), 0px 22px 53px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  padding: ${p => p.theme.space[32]};
  margin-bottom: ${p => p.theme.space[32]};
  > div {
    box-shadow: none;
    border-bottom: 1px solid ${p => p.theme.colors.gray[200]};
    padding: 0;
    margin-bottom: ${p => p.theme.space[24]};
    padding-bottom: ${p => p.theme.space[24]};
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: 0;
    }
  }
`
const ImgWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 16px;
  flex-shrink: 0;
  overflow: hidden;
  margin-right: ${p => p.theme.space[16]};
  img {
    width: 40px;
    height: 40px;
  }
`
const ButtonRow = styled.div`
  margin-top: ${p => p.theme.space[12]};
  display: flex;
  a {
    font-weight: 700;
    margin-right: 8px;
    text-decoration: underline;
    svg {
      height: 16px;
      vertical-align: middle;
      margin-top: --3px;
    }
  }
`

interface MeetupTalk {
  title: string
  author?: string
}
interface MeetupProps {
  highlighted?: boolean
  title: string
  talks?: MeetupTalk[]
  meetupLink: string
  youtubeLink?: string
  imagePath: string
}

const Meetup: React.FC<MeetupProps> = props => {
  return (
    <Wrapper>
      <ImgWrapper>
        <img src={assignPrefix(props.imagePath)} alt={props.title} />
      </ImgWrapper>
      <div>
        <strong>{props.title}</strong>
        {props.talks &&
          props.talks.map((talk, idx) => (
            <p key={`talk-${idx}`}>
              {talk.title}{' '}
              {talk.author && (
                <>
                  - <strong>{talk.author}</strong>
                </>
              )}
            </p>
          ))}
        <ButtonRow>
          {props.meetupLink && (
            <a href={props.meetupLink} target="_blank">
              Meetup <ArrowRight />
            </a>
          )}
          {props.youtubeLink && (
            <a href={props.youtubeLink} target="_blank">
              YouTube <ArrowRight />
            </a>
          )}
        </ButtonRow>
      </div>
    </Wrapper>
  )
}

export default Meetup
